import { FoodCard } from '@screens/HomePage/PlantVirusPage/FoodCard'; 
import { ReturnButton } from '@/components/shared/ReturnButton';
import { DataCardsCarousel } from './DataCardsCarousel';
import { useGetNutritionSummaryDetailBloodSugar } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { useLocation } from 'react-router-dom';

export const BloodSugarResponse = () => {
  const { data: bloodSugarResponse, isLoading } = useGetNutritionSummaryDetailBloodSugar();
  const location = useLocation();
  const { id } = location.state || {};
  const renderFoodCards = () => {
    if (isLoading) {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {[1, 2, 3, 4].map((index) => (
            <Skeleton
              key={index}
              className="h-20 rounded-xl"
            />
          ))}
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {bloodSugarResponse?.foods.map((food) => (
          <FoodCard
            key={food.food_id}
            id={food.food_id}
            name={food.food_name}
            imageUrl={food.food_image}
            rank={food.food_rank as 'Superfood' | 'Minimize' | 'Avoid'}
          />
        ))}
      </div>
    );
  };

  return (
    <section className="page-container">
      <div className="min-h-screen bg-background-secondary p-6 space-y-8">
        <ReturnButton/>
        <div className="space-y-2">
          <h1 className="typography-d2 text-primary">
            {bloodSugarResponse?.title}
          </h1>
          <p className="typography-body text-primary/70">
            {bloodSugarResponse?.info}
          </p>
        </div>
        <div className="space-y-6">
          <div className="flex items-start justify-between">
            <div className="space-y-4">
              <h2 className="typography-h1 text-primary">
                {bloodSugarResponse?.sub_title}
              </h2>
              <p className="typography-body text-primary/70">
                {bloodSugarResponse?.description}
              </p>
            </div>
          </div>
          {renderFoodCards()}
        </div>
        <DataCardsCarousel scoreId={id}/>
      </div>
    </section>
  );
};